import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { t } from "./i18n";

const ErrorComponent = () => <h2>{t("Component not found")}</h2>;

const Portal = ({ component, entity, language, video, active, loginUrl }) => {
    // Lazy-load components only when needed
    const components = {
        story: lazy(() => import("./Story")),
        promotion: lazy(() => import("./Promotion")),
        association: lazy(() => import("./Association")),
    };

    const Selected = components[component] || ErrorComponent;

    return (
        <Suspense fallback={<div>{t("Loading...")}</div>}>
            <Selected entity={entity} language={language} video={video} active={active} loginUrl={loginUrl} />
        </Suspense>
    );
};

// Entry point
const rootElements = document.querySelectorAll("[data-react-component], #root");

if (rootElements.length) {
    rootElements.forEach((rootElement) => {
        const component = rootElement.getAttribute("data-react-component") || rootElement.getAttribute("component");

        if (!component) {
            return;
        }

        const entity = rootElement.getAttribute("entity");
        const language = rootElement.getAttribute("language");
        const video = rootElement.getAttribute("video");
        const active = rootElement.getAttribute("active");
        const loginUrl = rootElement.getAttribute("data-login-url");

        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <Portal component={component} entity={entity} language={language} video={video} active={active} loginUrl={loginUrl} />
            </React.StrictMode>
        );
    });
} else {
    console.warn("Root element not found. React rendering skipped.");
}


